"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ActivityFeedChannel = exports.NotificationChannel = exports.NotificationAttentionLevel = exports.CustomerAccountNotificationStatus = exports.UserNotificationStatus = exports.NotificationType = exports.CustomerFields = exports.ShipmentFields = exports.BookingFields = exports.BaseEntityFields = exports.NotificationRequest = void 0;
class NotificationRequest {
}
exports.NotificationRequest = NotificationRequest;
class BaseEntityFields {
}
exports.BaseEntityFields = BaseEntityFields;
class BookingFields extends BaseEntityFields {
}
exports.BookingFields = BookingFields;
class ShipmentFields extends BaseEntityFields {
}
exports.ShipmentFields = ShipmentFields;
class CustomerFields extends BaseEntityFields {
}
exports.CustomerFields = CustomerFields;
var NotificationType;
(function (NotificationType) {
    NotificationType["Deviation"] = "deviation";
    NotificationType["DeviationRisk"] = "deviationRisk";
    NotificationType["Reassurance"] = "reassurance";
    NotificationType["Approval"] = "approval";
    NotificationType["OpenTask"] = "openTask";
    NotificationType["Message"] = "message";
    NotificationType["Update"] = "update";
    NotificationType["Activity"] = "activity";
})(NotificationType || (exports.NotificationType = NotificationType = {}));
var UserNotificationStatus;
(function (UserNotificationStatus) {
    UserNotificationStatus["Read"] = "read";
    UserNotificationStatus["UnRead"] = "unread";
    UserNotificationStatus["New"] = "new";
    UserNotificationStatus["UnSent"] = "unsent";
    UserNotificationStatus["Sent"] = "sent";
})(UserNotificationStatus || (exports.UserNotificationStatus = UserNotificationStatus = {}));
var CustomerAccountNotificationStatus;
(function (CustomerAccountNotificationStatus) {
    CustomerAccountNotificationStatus["Pending"] = "pending";
    CustomerAccountNotificationStatus["Complete"] = "complete";
    CustomerAccountNotificationStatus["Error"] = "error";
    CustomerAccountNotificationStatus["Cancelled"] = "cancelled";
})(CustomerAccountNotificationStatus || (exports.CustomerAccountNotificationStatus = CustomerAccountNotificationStatus = {}));
var NotificationAttentionLevel;
(function (NotificationAttentionLevel) {
    NotificationAttentionLevel["High"] = "high";
    NotificationAttentionLevel["Medium"] = "medium";
    NotificationAttentionLevel["Low"] = "low";
})(NotificationAttentionLevel || (exports.NotificationAttentionLevel = NotificationAttentionLevel = {}));
var NotificationChannel;
(function (NotificationChannel) {
    NotificationChannel["Email"] = "email";
    NotificationChannel["Slack"] = "slack";
    NotificationChannel["Web"] = "web";
})(NotificationChannel || (exports.NotificationChannel = NotificationChannel = {}));
exports.ActivityFeedChannel = 'activityFeed';
//# sourceMappingURL=notification.model.js.map